const styles = theme => ({
  '@keyframes purposeFadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(16px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  root: {
    height: '100dvh',
    justifyContent: 'center',
    backgroundColor: '#fff',
    alignItems: 'center',
    width: '100%',
    padding: 16,
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: '-10%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '900px',
      height: '500px',
      borderRadius: '50%',
      background:
        'linear-gradient(180deg, rgba(225, 251, 255, 0.50) 0%, rgba(254, 225, 80, 0.50) 100%)',
      filter: 'blur(150px)',
      zIndex: 0,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '5%',
      right: '20%',
      width: '400px',
      height: '400px',
      borderRadius: '50%',
      background: 'rgba(223, 208, 255, 0.6)',
      filter: 'blur(180px)',
      zIndex: 0,
    },
    [theme.breakpoints.down('md')]: {
      height: '100%',
      minHeight: '100vh',
    },
  },
  root_purpose_mobile: {
    justifyContent: 'center',
    width: '100%',
    maxHeight: '100%',
    height: '100%',
    padding: 16,
    display: 'flex',
    position: 'relative',
    zIndex: 1,
  },
  root_purpose: {
    height: '100%',
    justifyContent: 'center',
    backgroundColor: '#f4f6f8',
    width: '100%',
    display: 'flex',
  },
  main: {
    width: 'auto',
    display: 'block',

    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },

  video: {
    right: 0,
    bottom: 0,
    minWidth: '100%',
    minHeight: '100%',
  },

  image: {
    backgroundImage: 'url(/assets/signup_screen_newbg4.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    overflow: 'hidden',
    position: 'relative',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 32px',
    paddingLeft: '44px',
    width: '100%',
    height: '100%',
  },
  paper_purposeSelectionField: {
    display: 'flex',
    flexDirection: 'column', //padding: '0px 16px',
    /*     alignItems: 'center',
     */ width: '100%',
    height: '100%',
    //paddingLeft: '42px',
  },
  paper_mobile: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  paperText: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '84px',
  },
  paperText_mobile: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '24px',
  },

  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form_mobile: { maxWidth: 480 },
  submit: {
    marginTop: theme.spacing(3),
    height: '50px',
    borderRadius: '16px',
    backgroundColor: '#015FFB',
    width: '100%',
  },
  submit_bottom: {
    height: '50px',
    borderRadius: '16px',
    backgroundColor: '#015FFB',
    width: '100%',
    textTransform: 'none',
  },
  submit_mobile: {
    marginTop: theme.spacing(3),
    height: '50px',
    maxWidth: 500,
    borderRadius: '16px',
    backgroundColor: '#015FFB',
    width: '100%',
    textTransform: 'none',
  },
  submit_mobile_purposeSelection: {
    height: '50px',
    borderRadius: '16px',
    backgroundColor: '#015FFB',
    width: '100%',
  },
  combo: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: 'white',
    //borderWidth: 1,
    //borderStyle: 'solid',
    boxSizing: 'border-box',
    padding: theme.spacing(2),

    '&:hover': {
      borderColor: '#80bdff',
    },
  },
  overlayText: {
    maxWidth: '90%',
    padding: 20,
    margin: '5%',
    background: '#f0ffff14',
    bottom: 0,
    position: 'absolute',
    color: 'whitesmoke',
  },
  interestButtons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '130px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttonIndex: {
    color: '#808080',
    borderRadius: '4px',
    border: '1px solid #808080',
  },
  formGroup: {
    padding: '8px',
    //marginLeft: '8px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  formGroupCard: {
    borderRadius: '8px',
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    marginBottom: theme.spacing(1),
    boxShadow: 'none',
    border: '1px solid #808080',
    background: '#ffffff',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  formGroupCard_mobile: {
    borderRadius: '8px',
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    maxWidth: 500,
    marginBottom: theme.spacing(2),
    boxShadow: 'none',
    border: '1px solid #808080',
    background: '#ffffff',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  onBoardingRoot: {
    maxWidth: '1080px',
    height: '520px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    width: '100%',
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      height: '100%',
      padding: '0',
      justifyContent: 'flex-start',
      maxWidth: '100%',
      overflow: 'auto',
    },
  },
  onBoardingRoot_swiperWrapper: {
    maxWidth: '520px',
    width: '100%',
    height: '100%',
    marginRight: '20px',
    marginLeft: '0px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      width: '100%',
      marginRight: '0',
      marginBottom: '16px',
      height: 'auto',
    },
  },
  onBoardingRoot_leftSide: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: '520px',
    borderRadius: '24px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    gap: '32px',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '300px',
      maxWidth: '100%',
      marginBottom: 8,
    },
  },
  onBoardingRoot_leftSide_first: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '50%',
    borderRadius: '24px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    gap: '32px',
    justifyContent: 'center',
  },
  purpose_leftSide: {
    display: 'flex',
    flexDirection: 'column',
    //height: '100%',
    width: '100%',
    borderRadius: '24px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    gap: '32px',
  },
  onBoardingRoot_leftSide_middleImage: {
    width: '440px',
    height: '440px',
  },
  onBoardingRoot_leftSide_stepper: {
    margin: '0 auto',
    height: '10px',
  },
  onBoardingRoot_rightSide: {
    maxWidth: '540px',
    minWidth: '300px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      minWidth: 'auto',
    },
  },
  onBoardingRoot_rightSide_text: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1,
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
      flex: 'none',
    },
  },
  onBoardingRoot_padding_bottom: {
    paddingBottom: '12px',
  },
  onBoarding_FX: {
    flexGrow: 1,
  },
  circularProgress: {
    marginTop: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  onBoarding_buttonGroup: {
    width: '100%',
    height: '48px',
    display: 'flex',
    gap: 8,
    [theme.breakpoints.down('md')]: {
      marginTop: '16px',
    },
  },
  onBoardingRoot_skipButton: {
    color: '#919EAB',
    boxShadow: 'none',
    height: '100%',
    borderRadius: '12px',
  },
  onBoardingRoot_nextButton: {
    boxShadow: 'none',
    height: '100%',
    backgroundColor: '#015FFB',
    borderRadius: '12px',
    width: '100%',
    textTransform: 'none',
  },
  rootMobile: {
    justifyContent: 'center',
    backgroundColor: '#f4f6f8',
    width: '100%',
    display: 'flex',
    height: '100%',
    minHeight: '100vh',
  },
  onBoardingRootMobile: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    width: '100%',
    padding: '24px 16px',
    justifyContent: 'space-between',
  },
  onBoardingRoot_leftSideMobile: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '0',
    paddingBottom: '100%',
    position: 'relative',
    borderRadius: '24px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    marginBottom: 16,
  },
  onBoardingRoot_leftSide_middleImageMobile: {
    width: '300px',
    height: '300px',
  },
  onBoardingRoot_leftSide_stepperMobile: {
    margin: '0 auto',
    height: '10px',
  },
  onBoardingRoot_rightSideMobile: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  onBoardingRoot_rightSide_textMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  onBoarding_buttonGroupMobile: {
    display: 'flex',
    gap: 8,
    width: '100%',
    marginTop: '16px',
  },
  onBoardingRoot_skipButtonMobile: {
    color: '#919EAB',
    boxShadow: 'none',
    height: '100%',
    borderRadius: '12px',
  },
  onBoardingRoot_nextButtonMobile: {
    boxShadow: 'none',
    height: '100%',
    backgroundColor: '#015FFB!important',
    borderRadius: '12px',
    width: '100%',
    textTransform: 'none',
  },
  onBoardingHeader: {
    fontSize: '32px',
    fontWeight: 500,
    borderRadius: '8px',
    padding: '0px 8px',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
      padding: '0px 4px',
    },
  },
  onBoardingExplanation: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 400,
    padding: '0px 0px 0px 16px',
    margin: 0,
    fontFamily: 'Inter',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '20px',
      padding: '0px 0px 0px 8px',
      maxWidth: '369px',
      width: '100%',
    },
    '& ul': {
      listStyleType: 'none',
      margin: 0,
      padding: 0,
    },
    '& li': {
      marginBottom: '8px',
      '&:last-child': {
        marginBottom: 0,
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: '6px',
      },
    },
  },
  onBoardingDescription: {
    color: '#637381',
    fontSize: '18px',
    fontWeight: 500,
    padding: '0px 8px',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      padding: '0px 4px',
    },
  },
  purposePageRoot: {
    width: '100%',
    height: '100%',
    maxHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 1,
    padding: '24px 80px',
    [theme.breakpoints.down('md')]: {
      padding: '16px 0px',
      maxHeight: 'none',
      minHeight: '100dvh',
    },
    '@media (max-height: 800px) and (min-width: 960px)': {
      padding: '16px 80px',
    },
  },
  purposeLogo: {
    display: 'flex',
    alignItems: 'center',
    gap: '10.667px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '16px',
    },
  },
  purposeCenterContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    // 'safe center' centres as usual, but falls back to start-alignment as soon as the
    // content is taller than the container. Plain 'center' overflows equally in both
    // directions, and the top overflow cannot be scrolled to, which hid the Back button
    // on the branches with six options (L&D, Marketing) while the three-option branches
    // were fine. The plain 'center' fallback keeps older browsers on the old behaviour.
    fallbacks: [{ alignItems: 'center' }],
    alignItems: 'safe center',
    overflow: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    marginLeft: '-40px',
    animation: '$purposeFadeIn 500ms ease-in-out',
    '@media (max-height: 750px) and (min-width: 960px)': {
      alignItems: 'flex-start',
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      alignItems: 'flex-start',
      '& > *': {
        margin: 'auto',
      },
    },
  },
  purposeInterestWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '560px',
    maxWidth: '100%',
  },
  purposeSubtitle: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '18px',
    color: '#015FFB',
    textTransform: 'uppercase',
    lineHeight: 'normal',
  },
  purposeHeading: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: '32px',
    color: '#002E47',
    lineHeight: 'normal',
  },
  purposeOptionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    '@media (max-height: 800px)': {
      gap: '8px',
    },
  },
  purposeOptionCard: {
    borderRadius: '12px',
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    height: '64px',
    '@media (max-height: 800px)': {
      height: '52px',
    },
    boxShadow: 'none',
    border: '1px solid #CBD0D7',
    background: '#ffffff',
    alignItems: 'center',
    transition: 'border-color 0.15s ease, background-color 0.15s ease',
    '&:hover': {
      cursor: 'pointer',
      borderColor: '#015FFB !important',
    },
  },
  purposeOptionCard_mobile: {
    borderRadius: '12px',
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    height: '56px',
    boxShadow: 'none',
    border: '1px solid #CBD0D7',
    background: '#ffffff',
    alignItems: 'center',
    transition: 'border-color 0.15s ease, background-color 0.15s ease',
    '&:hover': {
      cursor: 'pointer',
      borderColor: '#015FFB !important',
    },
  },
  purposeOptionInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    padding: '16px',
    width: '100%',
    height: '100%',
    '@media (max-height: 800px)': {
      padding: '12px 16px',
    },
  },
  purposeOptionText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '18px',
    color: '#1D1D1F',
    lineHeight: 1.5,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  deliveryOptionCard: {
    borderRadius: '12px',
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    minHeight: '64px',
    boxShadow: 'none',
    border: '1px solid #CBD0D7',
    background: '#ffffff',
    transition: 'border-color 0.15s ease',
    '&:hover': {
      cursor: 'pointer',
      borderColor: '#015FFB !important',
    },
    '&:hover $deliveryIconWrapper': {
      backgroundColor: '#E3F3FF',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '56px',
    },
  },
  deliveryOptionInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    width: '100%',
    minHeight: '64px',
  },
  deliveryOptionLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
  },
  slidesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '560px',
    maxWidth: '100%',
    alignItems: 'flex-start',
    '@media (max-height: 750px) and (min-width: 960px)': {
      '& > .MuiBox-root': {
        marginTop: '12px !important',
      },
    },
  },
  slidesSubtitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '16px',
    color: '#015FFB',
    textTransform: 'uppercase',
    lineHeight: 'normal',
    letterSpacing: '0.5px',
  },
  slideImageCard: {
    width: '100%',
    height: '360px',
    borderRadius: '16px',
    backgroundColor: '#fff',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: '240px',
    },
    '@media (max-height: 750px) and (min-width: 960px)': {
      height: '240px',
    },
  },
  slideImageInner: {
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
  },
  slidesPagination: {
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    justifyContent: 'center',
    width: '100%',
  },
  slidesDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#CBD0D7',
    transition: 'all 0.2s ease',
  },
  slidesDotActive: {
    width: '24px',
    height: '8px',
    borderRadius: '4px',
    backgroundColor: '#015FFB',
    transition: 'all 0.2s ease',
  },
  slidesHeading: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '28px',
    color: '#002E47',
    lineHeight: 'normal',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
    },
    '@media (max-height: 750px) and (min-width: 960px)': {
      fontSize: '22px',
    },
  },
  slidesDescription: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '16px',
    color: '#637381',
    lineHeight: 1.6,
  },
  purposeSkipButton: {
    color: '#919EAB',
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeight: 500,
    textAlign: 'center',
    marginTop: '4px',
    cursor: 'pointer',
    lineHeight: '18px',
    padding: '10px 0',
    transition: 'color 0.15s ease',
    '&:hover': {
      color: '#637381',
    },
  },
  deliveryBackButton: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '16px',
    color: '#919EAB',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    '&:hover': {
      color: '#637381',
    },
  },
  deliveryDescriptionWrapper: {
    display: 'grid',
    gridTemplateRows: '0fr',
    transition: 'grid-template-rows 0.25s ease',
  },
  deliveryOptionDescription: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '16px',
    color: '#1D1D1F',
    lineHeight: 1.5,
    padding: '0 16px 16px 16px',
  },
  deliveryIconWrapper: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    backgroundColor: '#F4F6F8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    padding: '8px',
  },
})

export default styles
